import React  from "react";
import { AddMasterDataProps,  } from "./Index";
import { Title } from "../../../../../stories/Title/Title";
import InputHoc from "../../../../common/Input/Index";
import { Keys } from "../../../../../utils/Enum.keys";
import { Operation } from "../../../../../utils/Enum.types";
import useLabels from "../../../../../customHooks/useLabels";

const Add = ({ formData, handleValueChange, meta, operation }: AddMasterDataProps) => {
  const saveButton = document.getElementsByClassName("sub");
  const {itemLabel}=useLabels()
  return (
    <>
      <div className="master-data__add">
        <Title variant="subtitle1">{`${operation === Operation.UPDATE ? `Update` : "Add"} ${itemLabel} Group`}</Title>
        <div className="master-data__add--form">
          <InputHoc
            LabelName={`${itemLabel} Group Description`}
            values={formData.groupName}
            name="groupName"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleValueChange(e, meta)
            }
            onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
              if (e.key === Keys.ENTER) {
                if (saveButton.length) {
                  (saveButton[0] as HTMLButtonElement).focus();
                }
              }
            }}
            autoFocus
            required
          />
        </div>
      </div>
    </>
  );
};

export default Add;
